import React from "react";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import "./style.scss";
import { PUBLIC_URL } from "../../modules/App/configs/Constants";
import { useSelector } from "react-redux";
import { globalSettingSelector } from "../../modules/App/selectors/AppSelectors";

const MARKET_FALLBACK_COORDINATES: Record<
  string,
  { lat: number; lng: number }
> = {
  SG: { lat: 1.3521, lng: 103.8198 },
  TH: { lat: 13.7563, lng: 100.5018 },
  ID: { lat: -6.2088, lng: 106.8456 },
  PH: { lat: 14.5995, lng: 120.9842 },
  AU: { lat: -33.8688, lng: 151.2093 },
  HK: { lat: 22.3193, lng: 114.1694 },
  DE: { lat: 51.1657, lng: 10.4515 },
  AT: { lat: 47.5162, lng: 14.5501 },
};

const Map = ({
  lat,
  lng,
  zoom = 16,
  draggable,
  onDragEnd,
  marketCode,
}: any) => {
  const globalSetting = useSelector(globalSettingSelector);
  const isCoordinatesMissing = !lat || !lng;

  const marketChoose = globalSetting?.location?.find(
    ({ city_code }: { city_code: string }) => city_code === marketCode
  );

  const countryCenter = (() => {
    if (!marketCode) return null;
    const fromSetting =
      marketChoose?.lat && marketChoose?.lng
        ? {
            lat: parseFloat(marketChoose.lat),
            lng: parseFloat(marketChoose.lng),
          }
        : null;
    if (fromSetting && !isNaN(fromSetting.lat) && !isNaN(fromSetting.lng)) {
      return fromSetting;
    }
    return MARKET_FALLBACK_COORDINATES[marketCode] || null;
  })();

  if (isCoordinatesMissing && !countryCenter) {
    return null;
  }

  const center = !isCoordinatesMissing ? { lat, lng } : countryCenter;
  const currentZoom = isCoordinatesMissing ? 6 : zoom;

  return (
    <div>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*// @ts-ignore*/}
      <GoogleMap zoom={currentZoom} center={center}>
        {!isCoordinatesMissing && (
          <Marker
            icon={{
              url: PUBLIC_URL + "/assets/icons/icon-marker-blue.svg",
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              scaledSize: new window.google.maps.Size(80, 80),
            }}
            position={{ lat, lng }}
            draggable={draggable}
            onDragEnd={onDragEnd}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default withGoogleMap(Map);
